import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData,getAccessFunctions} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker,
  RespBkMthdMapp} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';
// import {Comp_Add_Product_Master} from '../components/comp_add_product_master';
// import {CompItem_Auto_Complete_New} from '../components/comp_auto_complete';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';


import defaultPic from '../assets/images/9.png';

//import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';
//import Comp_Read_Study_Material from '../lms_component/comp_read_study_material';
import {Comp_View_Pdf} from '../lms_component/comp_view_pdf';
import Comp_Test_Your_Know from '../lms_component/comp_test_your_know';
import Comp_Task_Officer_Sign from '../lms_component/comp_task_officer_sign';

import Comp_Bhandarkar_Book_Card from '../lms_component/comp_bhandarkar_book_card';
import Comp_Bhandarkar_Sidebar_Menu from '../lms_component/comp_bhandarkar_sidebar_menu';

import pdfIcon from '../assets/images/pdf_icon.png';
import mp3Icon from '../assets/images/mp3_icon.png';
import mp4Icon from '../assets/images/mp4_icon.png';

let loginUser="";
let userObject="";
let companyName="";
let clsProductMaster;

let rf="0";
let _objAccess={};
let _serFilters={ser_books_categories:""};



let objImages = [];
let indexExisting=0;
let arrExistingFiles=[];


let objVideo=[];
let vidIndexExisting=0;
let arrVidExistingFiles=[];

let objPdf=[];
let pdfIndexExisting=0;
let arrPdfExistingFiles=[];
let totalFileAllow=5;

class View_Task_List extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
          _objAccess=getAccessFunctions();
      }
      this.state={stSutudyMedia:{} ,stTaskList:[],stEditProduct:{},
                  stListCategories:[],stListItemCategory:[]};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsProductMaster=this;
      }
      

      // related to image upload sc

      //  check file validation
      fileValidation(){
        let allowFile=true;
     let imgCount=objImages.length;
     let vidCount=objVideo.length;
     let pdfCount=objPdf.length;

     let vTotalCount=imgCount+vidCount+pdfCount;
    
     if(vTotalCount>=totalFileAllow){
      alert("Only "+totalFileAllow+" to be allowed .");
      allowFile=false;
     }
     return allowFile;
 }
 //  check file validation  
 
rmFileProc(data,lsImages,thumbDiv){
  //alert("i m in in remove file "+lsImages);
  if(lsImages==="" || lsImages==="0"){
    lsImages="lsImages"
  }
  if(thumbDiv==="" || thumbDiv==="0"){
    thumbDiv="ref_div_";
  }
  
  if(document.getElementById(thumbDiv+data)!=null){
    document.getElementById(thumbDiv+data).remove();
  }
  
  this.lcRemoveJSON(data,"image",lsImages,thumbDiv);
}
lcRemoveJSON(refKey,fType,lsImages,thumbDiv){
  var jsonP=JSON.parse($("#"+lsImages).val());
  var arrJson=jsonP.objs;
  for(var ai=0;ai<arrJson.length;ai++){
    if(arrJson[ai]["name"]===refKey){
      arrJson.splice(ai,1);
      $("#"+lsImages).val(JSON.stringify(jsonP));
      break;
    }
  }
  objImages=arrJson;
}

  ImageThumbBackNew(flImg, flName,fObject,othInfo="",lsElement="",thumbnail="",isMultiple=false)
  {
       
        if(!this.fileValidation()){
          return;
        }
      
        if(flImg==="-10"){
          alert(flName);
          return;
        }
        if(lsElement===""){
          lsElement="lsImages"
        }
        let currentObject=null;
        let thumDiv="ref_div_";
        if(fObject){
          currentObject=fObject[0];
          if(currentObject.hasAttribute("thumbnail_div")){
            thumDiv=currentObject.getAttribute("thumbnail_div");
          }
      
        }
      
        if(othInfo===""){
          othInfo="nm"+indexExisting+","+indexExisting;
        }
        indexExisting++;
        var arrNmValue=othInfo.split(',');
        //arrExistingFiles.push
        arrExistingFiles[arrNmValue[1]]=arrNmValue[0];
        var strSet = "<div id=\""+thumDiv+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-6 lsthumb image_thumb_parent\">" +
        "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\" param3=\""+thumDiv+"\" param2=\""+lsElement+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
          "<a class=\"gallery-item\" href=\""+flImg+"\"><img src=\"" + flImg + "\"/></a>" +
          "</div>";
          if(flImg.indexOf("data:video/webm")!==-1 || flImg.indexOf("data:video/mp4")!==-1){
           strSet= "<div id=\""+thumDiv+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-12 lsthumb image_thumb_parent\">" +
            "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\"  param3=\""+thumDiv+"\" param2=\""+lsElement+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
              "<a class=\"gallery-item\" href=\""+flImg+"\"><video controls type=\"video/mp4\" src=\"" + flImg + "\"/></a>" +
              "</div>";
          }else if(flImg.indexOf("data:application/pdf")!==-1 || flImg.indexOf("data:application/pdf")!==-1){
            strSet= "<div id=\""+thumDiv+arrNmValue[1]+"\" class=\"col-lg-2 col-md-2 col-sm-2 col-12 lsthumb image_thumb_parent\">" +
            "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\"  param3=\""+thumDiv+"\" param2=\""+lsElement+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
              "<a class=\"gallery-item\" href=\""+flImg+"\"><img src="+pdfIcon+" /></a>" +
              "</div>";
          }
      
        
      
      
          
        //$("#audios").val("{\"objs\":" + JSON.stringify(objAudio) + "}");
        
       // alert(objImages.length);
      
       let tmpObjImages=[];
       if($("#"+lsElement).val()!==""){
        if(isMultiple===true){
          //alert("i min multiple");
          tmpObjImages=JSON.parse($("#"+lsElement).val());
          tmpObjImages=tmpObjImages.objs;
        }
       }
       tmpObjImages.push({ name: arrNmValue[1], value: flImg });
       $("#"+lsElement).val("{\"objs\":" + JSON.stringify(tmpObjImages) + "}");
        
        //alert(tmpObjImages.length);
        //alert(strSet);
      if(thumbnail===""){
        thumbnail="imgLibThumb";
      }
      //alert(thumbnail);
      if(isMultiple===false){
        $("."+thumbnail).html(strSet);
      }else{
        //alert("i m in append");
        $("."+thumbnail).append(strSet);
      }
      
        
        
        if(fObject!==null){
          fObject.val('');
        }
      //   $('.gallery-item').magnificPopup({
      //     type: 'image',
      //     gallery: {
      //         enabled: true
      //     }
      // });
      RespBkMthdMapp(clsProductMaster, "_removeBtn"+indexExisting, "rmFileProc", "2");
        //imgLibThumb
      }
      
      onDelOthImage(param1,param2,clickObject=null){
        let map=[];
        map.push({name:"curl_type",value:"removeImageContent"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"img_name",value:param1});
        map.push({name:"edit_id",value:param2});
        map.push({name:"img_of",value:"other"});
        map["res_func"]="callBackrrr";
        map["curl_type"]="removeImageContent";
        return;
        if(window.confirm("Please confirm do you want to delete permanently")){
          CallMapMethod_CBack(clsProductMaster,map,function(data,msg){
          //alert(data);
          if(data!=="0"){
           if(clickObject!==null){
           // alert(clickObject);
         if(clickObject!==""){
          
          
          let thumbDiv=clickObject;
          //alert(thumbDiv);
          if(document.getElementById(thumbDiv)!==null){
            //alert("i m in removed");
            document.getElementById(thumbDiv).remove();
          }
      
         }   
        
            
           }
           
          }
        });
      }
      }

      onDelMainImage(param1,param2,clickObject=null){
        
        let map=[];
        map.push({name:"curl_type",value:"removeImageContent"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"img_name",value:param1});
        map.push({name:"edit_id",value:param2});
        map.push({name:"img_of",value:"main"});
        map["res_func"]="callBackrrr";
        map["curl_type"]="removeImageContent";
        return;
        if(window.confirm("Please confirm do you want to delete permanently")){
          CallMapMethod_CBack(clsProductMaster,map,function(data,msg){
          //alert(data);
          if(data!=="0"){
           if(clickObject!==null){
           // alert(clickObject);
         if(clickObject!==""){
          
          
          let thumbDiv=clickObject;
          //alert(thumbDiv);
          if(document.getElementById(thumbDiv)!==null){
            //alert("i m in removed");
            document.getElementById(thumbDiv).remove();
          }
      
         }   
        
            
           }
           
          }
        });
      }
      
       }
// end of image upd       

      getCategories(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getCategoriesMaster"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"ser_text",value:$("#ser_text").val()});
       
        map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getCategoriesMaster";
        CallMapMethod_CBack(clsProductMaster,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                clsProductMaster.setState({stListCategories:listData},()=>{
                //   window.getPagination("#tbData");
                clsProductMaster.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                 
                  if(rf!=="0"){
                    clsProductMaster.getSearch(rf);
                    //alert("i m in setup "+rf);
                    $("#serLoanStatus").val(rf);
                  }
                });
              }
        });
      }

      setSearchPramasGb(serFilters){
        _serFilters=serFilters;
        clsProductMaster.getStudyMasterial();
      }

      getStudyMasterial(){
        //alert($("#ser_text").val());
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getStudyMasterial"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
        //map.push({name:"ser_userType",value:$("#ser_userType").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
        
        map.push({name:"ser_params",value:JSON.stringify(_serFilters)});
        
        //alert(JSON.stringify(serFilters));
        //alert(status);
        /*
        if(status!=="0"){
          map.push({name:"status",value:status});
        }
        not required as of now
        */
        map.push({name:"is_books",value:"0"});
        map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getStudyMasterial";
        CallMapMethod_CBack(clsProductMaster,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                for(let  i=0;i<listData.length;i++){
                  if(listData[i]["task_status"]!=="pending Sign" && listData[i]["task_status"]!=="Approved"){
                    //alert(JSON.stringify(listData[i]));
                    break;
                  }
                }
                clsProductMaster.setState({stTaskList:listData},()=>{
                  //window.getPagination("#tbData");
                  clsProductMaster.forceUpdateHandler();
              
                });
              }
        });
      }
      okRespProductAdd(data,msg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful",msg,true);
          //clsProductMaster.getProductMaster();
          $("#frmCreate").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Not Working",msg,false);
        }
        // alert(data);
      }


 setEditProductMaster(item){
  clsProductMaster.setState({stEditProduct:item});
 }
 onViewPdfNew(data){
  //alert(JSON.stringify(data));

  let mapNew=[];
  mapNew.push({name:"curl_type",value:"getMediaFromStudyMaterialId"});
  mapNew.push({name:"res_func",value:"callBackrrr"});
  mapNew.push({name:"local_token",value:userObject[0].id});
  mapNew.push({name:"user_type",value:userObject[0].type});
  mapNew.push({name:"study_material_id",value:btoa(data.id)})
  
  mapNew["res_func"]="callBackrrr";
  mapNew["curl_type"]="getMediaFromStudyMaterialId";
  CallMapMethod_CBack(clsProductMaster,mapNew,function(data,msg){
    //alert(data+"  "+msg);
    if(data!=="0"){
      let jsDataList=JSON.parse(data);
      if(jsDataList.study_media.length>0){
        clsProductMaster.setState({stSutudyMedia:jsDataList["study_media"][0]},()=>{
          clsProductMaster.forceUpdateHandler();
        });
      }
      
    }
  });


  
 }
 onViewPdf(data){
  // document.getElementById("divPdfView").style.display = "block";
  // alert("i am on clic of view pdf");
  //alert(JSON.stringify(data));
  clsProductMaster.setState({stItemProduct:data},()=>{
    RespBkMthdMapp(clsProductMaster,"_setbackparam","getParamData");
  });
}

SendApprovalRequest(){
  let mapNew=[];
  mapNew.push({name:"curl_type",value:"getSTO_CTO_Off"});
  mapNew.push({name:"res_func",value:"callBackrrr"});
  mapNew.push({name:"local_token",value:userObject[0].id});
  mapNew.push({name:"user_type",value:userObject[0].type});
  Custom_Alert("Option not available","Not available to sync",false);
}              
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getCategories();
this.getStudyMasterial();

$('#divPdfView').on('hidden.bs.modal', function () {
  //clsProductMaster.getStudyMasterial();
  //clsProductMaster.setState({stSutudyMedia:""});
});

$('#divTaskOfficerSign').on('hidden.bs.modal', function () {
  clsProductMaster.getStudyMasterial();
});

$('#divTestYourKnow').on('hidden.bs.modal', function () {
  clsProductMaster.getStudyMasterial();
});


}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
  {/* <CompItem_Auto_Complete_New setData={true} autoList={this.state.listUsers}/> */}
<div className="row content12 mt-2 mb-2">

<div class="col-6">
<button onClick={()=>this.SendApprovalRequest()}  style={{marginRight:"10px"}} className="btn btn-sm btn-primary">(⟳)Send/Receive Approval Request</button>
</div>

<div className='col-lg-4 col-md-4 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_text" name="ser_text" className="_setSearchKeyUp form-control form-control-sm" placeholder='search by Task Index,Function and Description' />
             </div>
         
         </div>

</div>

<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 <div onClick={()=>this.getStudyMasterial()}  style={{marginRight:"10px"}} className="btn btn-sm btn-danger">Search</div>
                 <div onClick={()=>window.location.reload()}  className="btn btn-sm btn-danger">Reset</div>
                 </div>
               </div>
             </div>

</div>
    </div>    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Task List</b></h3>
          </div>
              <div class="container111 py-3">
        
            <div className='table-responsive'>
            <table id="tbData" className='dtgrid table table-bordered table-hover text-sm'>
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>Task_Id</th>
                      <th>Semester</th>
                      <th>Funciton</th>
                      
                      <th>Topic</th>
                      <th>Task No.</th>
                      <th>Sub Task No.</th>
                      <th>Task Index</th>
                      <th>Short Description</th>
                      
                      <th>Task Status</th>
                      {/* <th>Is Active</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.stTaskList.map((item,index)=>{
                    let styColor="";
                    //alert(item["id"]+item["task_status"]);
                    if(item["main_category"]==="Semester3"){
                      styColor="sem3";
                    }else if(item["main_category"]==="Semester4"){
                      styColor="sem4 white";
                    }else if(item["main_category"]==="Semester5"){
                      styColor="sem5 white";
                    }
                       return(<tr >
                        <td>{index+1}</td>
                  <td>{item["id"]}</td>
                  <td><span class={styColor}>{item["main_category"]}</span></td>      
                  <td>{item["category_name"]}</td>
                  <td>{item["topic_title"]}</td>
                  <td>{item["task_no"]}</td>
                  <td>{item["sub_task_nos"]}</td>
                  <td>{item["task_index"]}
                  {item["file_path_2"]!==""?<a> / (with animation)</a>:''}
                  </td>
                  <td>{item["short_description"]}</td>
                  <td>{item?.task_status != null && item?.task_status !== ""?<span class="badge badge-info">{item["task_status"]}</span>: "Pending"}</td>
                  {/* <td>{item.is_active}</td> */}
                  <td>
                  <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown"  aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu">
                    {item?.task_status == null || item.task_status === "" || 0===0?<a href="javascript:void(0)" class="dropdown-item" onClick={()=>this.onViewPdfNew(item)} data-bs-toggle="modal" data-bs-target="#divPdfView">Study Task</a>:''} 
                    {item?.task_status == null || item.task_status === "" || 0===0?<a href="javascript:void(0)" class="dropdown-item" onClick={()=>this.onViewPdf(item)} data-bs-toggle="modal" data-bs-target="#divTestYourKnow">Test Your Knowledge</a>:''} 
                    {item["task_status"]==="pending Sign" || 0===0?<a class="dropdown-item" onClick={()=>this.onViewPdf(item)}  data-bs-toggle="modal" data-bs-target="#divTaskOfficerSign" data-toggle="modal"  data-target="#divTaskOfficerSign" href="javascript:void(0)">Officer's Approval</a>:''}
                    {item["task_status"]==="Approved"?<a class="dropdown-item" onClick={()=>this.onViewPdf(item)}  data-bs-toggle="modal" data-bs-target="#divTestYourKnow" data-toggle="modal"  data-target="#divTestYourKnow" href="javascript:void(0)">View Approved Task</a>:''}
                    </div>
                  </div>
                    </td>
                    </tr>)
                  }))}
                  </tbody>
                </table>

            
            {/* <div class="col-3">
                <Comp_Bhandarkar_Sidebar_Menu runSearch={this.setSearchPramasGb} listCategories={this.state.stListCategories}/>
                </div>
          <div class="col-9 book-detail-card">
              <Comp_Bhandarkar_Book_Card onViewBook={this.onViewPdf} bookList={this.state.listUsers} />
              </div> */}
              </div>
              </div>
                
                <div class='pagination-container' >
				<nav>
				  <ul class="pagination">
            
            <li data-page="prev" >
								     <span> {"<"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  
        <li data-page="next" id="prev">
								       <span> {">"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  </ul>
				</nav>
			</div>
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
{/* <Alert_Content/> */}
<Footer/>
<Comp_View_Pdf userObject={userObject} isSemester={true} proItem={this.state.stSutudyMedia} />
<Comp_Test_Your_Know userObject={userObject}  proItem={this.state.stItemProduct} />
<Comp_Task_Officer_Sign userObject={userObject}  proItem={this.state.stItemProduct} />
{/* <Comp_Read_Study_Material pdfSource={"https://lmstestd.bhandarkarpublications.com/dtup/A1.1.pdf"}/> */}
{/* <Comp_Add_Product_Master editProduct={this.state.stEditProduct} logUser={userObject} lsUnit={this.state.stListUnit} lsProCategory={this.state.stListItemCategory}/> */}

    {/* <Wa_Credit_Balance_Comp creditUser={this.state.crediUser} creditBalance={this.state.creditBalance} masterBalance={this.state.masterBalance} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default View_Task_List;